module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/bairro/bairro.component.css
// module id = ./src/app/bairro/bairro.component.css
// module chunks = main